import store from '../../store';

const open = (images, index) => {
	if (!images || images.length == 0) return;
	const idx = index || 0;

	store.dispatch('win/push', {
		component: 	'gallery-window-view',
		images:		images,
		index:		idx
	});
};

export default {
	open
};